import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="lds-ring-2">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default LoadingSpinner;
